module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit":"Редактировать","delete":"Удалить","question":"Вопрос","answer":"Ответ","close":"Закрыть","save":"Сохранить","deleteWarning":"Вы уверены, что хотите удалить вопрос?","yes":"Да","no":"Нет"}}')
  delete Component.options._Ctor
}
